import { observer } from 'mobx-react-lite';
import type { WeekAvailability } from '../../../types/availability';
import { TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { useVersionAvailability } from '../hooks/useVersionAvailability';
import { ResourceAvailabilityMatrix } from './ResourceAvailabilityMatrix';

type TimetableVersionClassesMatrixProps = {
  selectedUuid: string;
  versionUuid?: string | null;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  onChange: (availability: WeekAvailability) => void;
};

export const TimetableVersionClassesMatrix = observer(
  ({ selectedUuid, versionUuid, timeGridEntries, loading, onChange }: TimetableVersionClassesMatrixProps) => {
    const { availability, fetching, execute } = useVersionAvailability(versionUuid, 'class', selectedUuid);
    return (
      <ResourceAvailabilityMatrix
        availability={availability}
        timeGridEntries={timeGridEntries}
        loading={loading}
        fetching={fetching}
        onChange={onChange}
        execute={execute}
      />
    );
  },
);
